import React from 'react'
import styled from 'styled-components'
import { MyLink } from 'components/common/link'
import { FloatingButton } from 'components/scouts/common/styles'
import { analytics } from 'infra/analytics'
import { kakao } from 'infra/kakao'
import { useIsLoggedIn } from 'utils/hooks'
import { GuideBalloon } from 'components/scouts/landing/cta-button'
import { Layout } from 'components/scouts/greeting/styles'
import { useRouter } from 'next/router'

export const CTAButton = () => {
  const isLoggedIn = useIsLoggedIn()
  const router = useRouter()
  return (
    <MyLink
      href='/scouts/request-form/job-search-status'
      onClick={(e) => {
        analytics.track('greeting_jsu_click_cta')
        if (isLoggedIn) return
        e.preventDefault()
        router.replace('?start-scout').then(() => kakao.login())
      }}
    >
      <GreetingButton>
        {isLoggedIn
          ? '👉🏻 프로필 등록하고 스카우트 제안받기'
          : '👉🏻 3초만에 가입하고 스카우트 제안받기'}
      </GreetingButton>
    </MyLink>
  )
}

export const BottomCTAButton = () => {
  return (
    <Bottom>
      <div style={{ position: 'relative', width: '100%' }}>
        <GuideBalloon>
          희망 구직 조건을 등록하고, 딱 맞는 제안만 받아보세요!
        </GuideBalloon>
        <CTAButton />
      </div>
    </Bottom>
  )
}

export const GreetingButton = styled(FloatingButton)`
  @media ${(p) => p.theme.deviceSize.desktop} {
    padding: 24px;
    font-size: 20px;
    border-radius: 50px;
  }
`

const Bottom = styled(Layout)`
  position: sticky;
  @media ${(p) => p.theme.deviceSize.mobile} {
    padding: 0;
    bottom: 20px;
    left: 0;
  }
  @media ${(p) => p.theme.deviceSize.desktop} {
    bottom: 0px;
    width: 400px;
  }
`
